import React, { useState, useEffect, useMemo, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInAnonymously,
  onAuthStateChanged,
} from 'firebase/auth';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  onSnapshot,
  doc,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import {
  AlertCircle,
  Check,
  Clipboard,
  ClipboardCheck,
  Layers,
  List,
  Search,
  CheckCircle,
  Truck,
  Phone,
  Box,
  Shirt,
  History,
  Save,
  ArrowLeft,
  ArrowRight,
  MapPin,
  MessageCircle,
  Sun,
  Moon,
} from 'lucide-react';

// --- CONFIG FIREBASE (injectada des d'index.html) ---
const firebaseConfig = JSON.parse(window.__firebase_config);
const appId = window.__app_id || 'gestio-epis';

// --- ESTOC REG: metadades (peça + talla) ---
const EPI_META_REG = {
  "G01": {
    "peca": "Jaquetó",
    "talla": "SMALL-SHORT"
  },
  "G02": {
    "peca": "Jaquetó",
    "talla": "SMALL-SHORT"
  },
  "G03": {
    "peca": "Jaquetó",
    "talla": "SMALL-REGULAR"
  },
  "G04": {
    "peca": "Jaquetó",
    "talla": "SMALL-TALL"
  },
  "G05": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-SHORT"
  },
  "G06": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-REGULAR"
  },
  "G07": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-REGULAR"
  },
  "G08": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-TALL"
  },
  "G09": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-TALL"
  },
  "G10": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-XTALL"
  },
  "G11": {
    "peca": "Jaquetó",
    "talla": "LARGE-REGULAR"
  },
  "G12": {
    "peca": "Jaquetó",
    "talla": "LARGE-TALL"
  },
  "G13": {
    "peca": "Pantaló",
    "talla": "SMALL-SHORT"
  },
  "G14": {
    "peca": "Pantaló",
    "talla": "SMALL-REGULAR"
  },
  "G15": {
    "peca": "Pantaló",
    "talla": "SMALL-REGULAR"
  },
  "G16": {
    "peca": "Pantaló",
    "talla": "SMALL-TALL"
  },
  "G17": {
    "peca": "Pantaló",
    "talla": "SMALL-TALL"
  },
  "G18": {
    "peca": "Pantaló",
    "talla": "SMALL-XTALL"
  },
  "G19": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G20": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G21": {
    "peca": "Pantaló",
    "talla": "MEDIUM-TALL"
  },
  "G22": {
    "peca": "Pantaló",
    "talla": "MEDIUM-TALL"
  },
  "G23": {
    "peca": "Pantaló",
    "talla": "MEDIUM-XTALL"
  },
  "G24": {
    "peca": "—",
    "talla": "Desaparegut"
  },
  "G25": {
    "peca": "Jaquetó",
    "talla": "SMALL-REGULAR"
  },
  "G26": {
    "peca": "Jaquetó",
    "talla": "SMALL-REGULAR"
  },
  "G27": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-SHORT"
  },
  "G28": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-SHORT"
  },
  "G29": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-REGULAR"
  },
  "G30": {
    "peca": "Jaquetó",
    "talla": "MEDIUM-REGULAR"
  },
  "G31": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G32": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G33": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G34": {
    "peca": "Pantaló",
    "talla": "MEDIUM-REGULAR"
  },
  "G35": {
    "peca": "Pantaló",
    "talla": "MEDIUM-SHORT"
  },
  "G36": {
    "peca": "Pantaló",
    "talla": "MEDIUM-SHORT"
  },
  "G37": {
    "peca": "Jaquetó",
    "talla": "X-LARGE-REGULAR"
  },
  "G38": {
    "peca": "Jaquetó",
    "talla": "X-LARGE-REGULAR"
  },
  "G39": {
    "peca": "Pantaló",
    "talla": "LARGE-REGULAR"
  },
  "G40": {
    "peca": "Pantaló",
    "talla": "X-LARGE-TALL"
  }
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// --- DADES DE SUPORT ---

const PARCS_INICIALS = [
  'Girona',
  'Santa Coloma',
  'Lloret',
  'Amer',
  'Tàrrega',
  'Olot',
  'Figueres',
  'Cassà',
  'Maçanet',
  'La Pera',
  'Torroella',
  'Roses',
  'Llançà',
  'La Jonquera',
  'Hostalric',
];

const REGIONS = [
  'Girona',
  'Lleida',
  'Tarragona',
  'Metropolitana Nord',
  'Metropolitana Sud',
  'Centre',
  "Terres de l'Ebre",
  'Val d’Aran',
];

/**
 * Telèfons per parc.
 * IMPORTANT: posa aquí els números reals en format internacional sense +
 * Ex: 'Girona': '34972XXXXXX'
 */
const PARC_PHONES = {
  Girona: '34667085255', // posa aquí 34972...
  'Santa Coloma': '',
  Lloret: '',
  Amer: '',
  Tàrrega: '',
  Olot: '',
  Figueres: '',
  Cassà: '',
  Maçanet: '',
  'La Pera': '',
  Torroella: '',
  Roses: '',
  Llançà: '',
  'La Jonquera': '',
  Hostalric: '',
};

// --- COMPONENTS AUXILIARS ---

const Badge = ({ color, children }) => {
  const colors = {
    red: 'bg-red-100 text-red-800 border-red-200',
    green: 'bg-green-100 text-green-800 border-green-200',
    yellow: 'bg-amber-100 text-amber-800 border-amber-200',
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    purple: 'bg-purple-100 text-purple-800 border-purple-200',
    gray: 'bg-gray-100 text-gray-800 border-gray-200',
  };

  return (
    <span
      className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${
        colors[color] || colors.gray
      }`}
    >
      {children}
    </span>
  );
};

const PhonePill = ({ tel, tone = 'amber' }) => {
  const tones = {
    amber: {
      text: 'text-amber-900',
      border: 'border-amber-200',
      bg: 'bg-amber-50',
      muted: 'text-amber-900/50',
    },
    gray: {
      text: 'text-gray-900',
      border: 'border-gray-200',
      bg: 'bg-white',
      muted: 'text-gray-400',
    },
    rose: {
      text: 'text-rose-900',
      border: 'border-rose-200',
      bg: 'bg-rose-50',
      muted: 'text-rose-900/50',
    },
    blue: {
      text: 'text-blue-900',
      border: 'border-blue-200',
      bg: 'bg-blue-50',
      muted: 'text-blue-900/50',
    },
    green: {
      text: 'text-green-900',
      border: 'border-green-200',
      bg: 'bg-green-50',
      muted: 'text-green-900/50',
    },
  };

  const t = tones[tone] || tones.gray;

  if (!tel) {
    return <span className={`italic ${t.muted}`}>Sense telèfon</span>;
  }

  return (
    <span
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border ${t.border} ${t.bg} ${t.text} font-semibold`}
      title="Telèfon del parc"
    >
      <Phone size={14} />
      <span className="font-mono">{tel}</span>
    </span>
  );
};



export default function App() {
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(() => {
    try {
      const saved = localStorage.getItem('epiges_theme');
      if (saved === 'light' || saved === 'dark') return saved;
      const prefersDark =
        window.matchMedia &&
        window.matchMedia('(prefers-color-scheme: dark)').matches;
      return prefersDark ? 'dark' : 'light';
    } catch (e) {
      return 'light';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('epiges_theme', theme);
    } catch (e) {}
  }, [theme]);

  const [activeTab, setActiveTab] = useState('home'); // home | assignar | historic | trucades | recollir | retorns | estoc | cercador // dashboard | assignar | historic | seguiment

  // --- Estoc REG (Bloc 3) controls ---
  const [estocSearch, setEstocSearch] = useState('');
  const [estocFilterPeca, setEstocFilterPeca] = useState('ALL'); // ALL | Jaquetó | Pantaló | NONE
  const [estocSortKey, setEstocSortKey] = useState('code'); // code | peca | talla | estat | onEs
  const [estocSortDir, setEstocSortDir] = useState('asc'); // asc | desc
  const [epis, setEpis] = useState([]);
  const [parcPhones, setParcPhones] = useState({});
  const [loading, setLoading] = useState(true);

  const [nouEpi, setNouEpi] = useState({
    codiEpi: '',
    codiEpi2: '',
    nomBomber: '',
    codiBomber: '',
    parc: 'Girona',
    regio: 'Girona',
    nomGD0: '',
    dataEntrega: new Date().toISOString().split('T')[0],
  });
  // --- CERCA PER CODI EPI (G05) ---
  const [searchEpi, setSearchEpi] = useState('');

  // --- TOASTS (confirmacions) ---
  const [toast, setToast] = useState({ open: false, type: 'success', message: '' });
  const toastTimerRef = useRef(null);

  // Helper centralitzat per mostrar toasts (evita duplicats i assegura autoclose)
  const showToast = (message, type = 'success') => {
    try {
      if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    } catch (e) {}

    setToast({ open: true, type, message });

    // Autoclose suau (3s)
    toastTimerRef.current = setTimeout(() => {
      setToast((prev) => ({ ...prev, open: false }));
    }, 3000);
  };

  // Netegem timer en unmount
  useEffect(() => {
    return () => {
      try {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
      } catch (e) {}
    };
  }, []);

  // --- BUSY (bloqueig doble clic per accions crítiques) ---
  const [busyMap, setBusyMap] = useState({});
  const isBusy = (key) => Boolean(key && busyMap[key]);
  const setBusyOn = (key) => setBusyMap((prev) => ({ ...prev, [key]: true }));
  const setBusyOff = (key) =>
    setBusyMap((prev) => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
  // Modal per marcar retorn capsa/roba
  const [retornModal, setRetornModal] = useState({
    open: false,
    epi: null,
    tipus: null, // 'capsa' | 'epi'
    date: new Date().toISOString().split('T')[0],
  });

  // --- Estoc REG sorting handler ---
  const handleEstocSort = (key) => {
    setEstocSortKey((prevKey) => {
      if (prevKey === key) {
        setEstocSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prevKey;
      }
      setEstocSortDir('asc');
      return key;
    });
  };

  // --- AUTH ANÒNIMA ---
  useEffect(() => {
    const initAuth = async () => {
      await signInAnonymously(auth);
    };
    initAuth();

    const unsub = onAuthStateChanged(auth, (u) => setUser(u));
    return () => unsub();
  }, []);

  // --- CARREGA DADES EN TEMPS REAL ---
  useEffect(() => {
    if (!user) return;
    const q = query(
      collection(db, 'artifacts', appId, 'public', 'data', 'epis_reg_registre'),
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        const items = snapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        // Ordenem per dataEntrega (més recent primer)
        items.sort(
          (a, b) =>
            new Date(b.dataEntrega || b.timestamp?.toDate?.() || 0) -
            new Date(a.dataEntrega || a.timestamp?.toDate?.() || 0),
        );
        setEpis(items);
        setLoading(false);
      },
      (error) => {
        console.error('Error carregant dades:', error);
        setLoading(false);
      },
    );

    return () => unsub();
  }, [user]);
  // --- CARREGA TELÈFONS DE PARC (Firestore: /parcs) ---
  useEffect(() => {
    if (!user) return;

    const unsub = onSnapshot(
      query(
        collection(db, 'artifacts', appId, 'public', 'data', 'parcs'),
      ),
      (snap) => {
        const map = {};
        snap.forEach((d) => {
          const data = d.data() || {};
          const nom = (data.nom || d.id || '').toString();
          if (!nom) return;
          const tel = (data.telefon || data.tel || '').toString().trim();
          if (tel) map[nom] = tel;
        });
        setParcPhones(map);
      },
      (err) => console.error('Error carregant parcs:', err),
    );

    return () => unsub();
  }, [user]);

  // --- HELPERS FIRESTORE ---

  const updateEpiStatus = async (id, updates) => {
    if (!user) return;
    const ref = doc(
      db,
      'artifacts',
      appId,
      'public',
      'data',
      'epis_reg_registre',
      id,
    );
    await updateDoc(ref, updates);
  };

  // --- PARCS DISPONIBLES (per datalist) ---
  const parcsDisponibles = useMemo(() => {
    const setParcs = new Set(epis.map((e) => e.parc).filter(Boolean));
    PARCS_INICIALS.forEach((p) => setParcs.add(p));
    return Array.from(setParcs).sort((a, b) =>
      a.localeCompare(b, 'ca', { sensitivity: 'base' }),
    );
  }, [epis]);

  // --- DERIVATS ---
  const episActiusBase = useMemo(
    () => epis.filter((e) => e.estat !== 'tornat'),
    [epis],
  );

  // --- HELPERS: detectar assignació doble (amb suport a registres antics) ---
  
  // --- Estoc REG rows (40 EPIs) with search/filter/sort ---
  const estocRows = useMemo(() => {
    const base = Array.from({ length: 40 }, (_, i) => `G${String(i + 1).padStart(2, '0')}`).map((code) => {
      const actiu = episActiusBase.find((e) => (e.codiEpi || '').toUpperCase() === code);
      let estat = 'A REG';
      let onEs = 'REG';

      if (actiu) {
        const neteja = (actiu.estatNeteja || 'pendent').toLowerCase();
        estat = 'Fora';
        onEs = actiu.parc || 'Fora';

        if (actiu.capsaTornada && !actiu.epiTornat) {
          estat = 'A ELIS';
          onEs = `${actiu.parc || 'Parc'} (EPI a rentar)`;
        }
        if (neteja === 'pendent') {
          estat = 'Fora (pendent trucada)';
        }
      }

      const peca = EPI_META_REG?.[code]?.peca || '';
      const talla = EPI_META_REG?.[code]?.talla || '';

      return { code, peca, talla, estat, onEs };
    });

    // Filter by peça
    let rows = base;
    if (estocFilterPeca === 'NONE') rows = rows.filter((r) => !r.peca || r.peca === '—');
    if (estocFilterPeca === 'Jaquetó') rows = rows.filter((r) => (r.peca || '').toLowerCase() === 'jaquetó');
    if (estocFilterPeca === 'Pantaló') rows = rows.filter((r) => (r.peca || '').toLowerCase() === 'pantaló');

    // Search
    const q = (estocSearch || '').trim().toLowerCase();
    if (q) {
      rows = rows.filter((r) => {
        return (
          (r.code || '').toLowerCase().includes(q) ||
          (r.peca || '').toLowerCase().includes(q) ||
          (r.talla || '').toLowerCase().includes(q) ||
          (r.estat || '').toLowerCase().includes(q) ||
          (r.onEs || '').toLowerCase().includes(q)
        );
      });
    }

    // Sort
    const dir = estocSortDir === 'asc' ? 1 : -1;
    const get = (r) => {
      switch (estocSortKey) {
        case 'peca':
          return r.peca || '';
        case 'talla':
          return r.talla || '';
        case 'estat':
          return r.estat || '';
        case 'onEs':
          return r.onEs || '';
        case 'code':
        default:
          return r.code || '';
      }
    };

    rows = rows.slice().sort((a, b) => {
      const va = get(a);
      const vb = get(b);
      // Numeric-friendly compare for codes
      return String(va).localeCompare(String(vb), 'ca', { numeric: true, sensitivity: 'base' }) * dir;
    });

    return rows;
  }, [episActiusBase, estocSearch, estocFilterPeca, estocSortKey, estocSortDir]);

const _doubleAssignKeys = useMemo(() => {
    const groupCounts = new Map();
    const legacy = new Map(); // key -> {count, minTs, maxTs}

    const getTs = (e) => {
      try {
        return e?.timestamp?.toDate ? e.timestamp.toDate() : null;
      } catch {
        return null;
      }
    };

    const legacyKey = (e) => {
      const b = (e.codiBomber || '').toString().trim().toUpperCase();
      const p = (e.parc || '').toString().trim();
      const d = (e.dataEntrega || '').toString().trim();
      const g = (e.nomGD0 || '').toString().trim();
      return `${b}|${p}|${d}|${g}`;
    };

    for (const e of epis || []) {
      if (e.assignacioGroupId) {
        groupCounts.set(e.assignacioGroupId, (groupCounts.get(e.assignacioGroupId) || 0) + 1);
      } else {
        const k = legacyKey(e);
        if (!k || k.startsWith('|')) continue;
        const ts = getTs(e);
        const cur = legacy.get(k) || { count: 0, minTs: ts, maxTs: ts };
        cur.count += 1;
        if (ts) {
          cur.minTs = cur.minTs ? (ts < cur.minTs ? ts : cur.minTs) : ts;
          cur.maxTs = cur.maxTs ? (ts > cur.maxTs ? ts : cur.maxTs) : ts;
        }
        legacy.set(k, cur);
      }
    }

    const doubleGroupIds = new Set();
    for (const [gid, c] of groupCounts.entries()) {
      if (c >= 2) doubleGroupIds.add(gid);
    }

    const legacyDoubleKeys = new Set();
    for (const [k, info] of legacy.entries()) {
      // Heurística segura: exactament 2 registres, creats molt junts (o sense timestamps)
      if (info.count >= 2) {
        if (!info.minTs || !info.maxTs) {
          legacyDoubleKeys.add(k);
        } else {
          const diffMs = info.maxTs.getTime() - info.minTs.getTime();
          if (diffMs <= 60 * 60 * 1000) legacyDoubleKeys.add(k); // 60 min
        }
      }
    }

    return { doubleGroupIds, legacyDoubleKeys, legacyKey };
  }, [epis]);

  const isDoubleAssign = (e) => {
    if (!e) return false;
    if (e.assignacioCount === 2) return true;
    if (e.assignacioGroupId) return _doubleAssignKeys.doubleGroupIds.has(e.assignacioGroupId);
    const k = _doubleAssignKeys.legacyKey(e);
    return _doubleAssignKeys.legacyDoubleKeys.has(k);
  };


  // Actius (sense filtre per codi; el cercador està al bloc de Consulta)
  const episActius = useMemo(() => episActiusBase, [episActiusBase]);

  const perTrucar = useMemo(
    () => episActius.filter((e) => e.estatNeteja === 'pendent'),
    [episActius],
  );

  const episNets = useMemo(
    () =>
      episActius.filter(
        (e) => e.estatNeteja === 'net' && e.estat !== 'tornat',
      ),
    [episActius],
  );

  const episBruts = useMemo(
    () =>
      episActius.filter(
        (e) => e.estatNeteja === 'brut' && e.estat !== 'tornat',
      ),
    [episActius],
  );

  // Pendents de recollir (després de marcar NET/BRUT i abans d'enviar WhatsApp global)
  const pendentsRecollir = useMemo(() => {
    return episActius.filter((e) => {
      const estat = (e.estatNeteja || 'pendent');
      const enviat = Boolean(e.logisticaEnviat);
      // només els que ja tenen resultat (net/brut) i encara no s'han comunicat a logística
      return (estat === 'net' || estat === 'brut') && !enviat && e.estat !== 'tornat';
    });
  }, [episActius]);

  // Pendents de retorn físic (després d'haver enviat a logística)
  const pendentsRetorns = useMemo(() => {
    // Qualsevol EPI actiu que encara no estigui completament retornat.
    // Això inclou casos on torna la capsa o l'EPI abans fins i tot de fer la trucada.
    return episActius.filter((e) => {
      return e.estat !== 'tornat' && !(e.capsaTornada && e.epiTornat);
    });
  }, [episActius]);

  const countsHome = useMemo(() => {
    const trucades = perTrucar.length;
    const recollir = pendentsRecollir.length;
    const retorns = pendentsRetorns.length; // ha de coincidir amb la pantalla "Pendents de retorns"
    return { trucades, recollir, retorns };
  }, [perTrucar.length, pendentsRecollir.length, pendentsRetorns.length]);
  const historicsBase = useMemo(
    () => epis.filter((e) => e.estat === 'tornat'),
    [epis],
  );

    const historics = useMemo(() => historicsBase, [historicsBase]); 

  const onClickPendentsTrucada = () => {
    // Mantinc el teu comportament: obrir "seguiment"
    setActiveTab('trucades');
    // scroll al top de la vista
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  // --- CREAR NOVA ASSIGNACIÓ ---

  const handleAssignar = async (e) => {
    e.preventDefault();
    if (!user) return;

    if (!nouEpi.codiEpi || !nouEpi.codiBomber || !nouEpi.nomGD0 || !nouEpi.parc) {
      showToast('Falten camps obligatoris (EPI, codi bomber, parc i GD0).', 'error');
      return;
    }

    const normalizeEpiForStore = (codeRaw) => {
      let c = (codeRaw || '').toString().trim().toUpperCase();
      if (!c) return '';
      if (!c.startsWith('G')) c = `G${c}`;
      return c;
    };

    const generateGroupId = () => {
      try {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
      } catch {
        // ignore
      }
      return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
    };

    const codi1 = normalizeEpiForStore(nouEpi.codiEpi);
    const codi2 = normalizeEpiForStore(nouEpi.codiEpi2);

    // Si hi ha segon EPI, no pot ser el mateix
    if (codi2 && codi2 === codi1) {
      showToast('El segon EPI no pot ser el mateix que el primer.', 'error');
      return;
    }

    const codiBomberFinal = nouEpi.codiBomber.trim().toUpperCase();

    // No guardem codiEpi2 dins el document (només guardem el codi final a cada registre)
    const { codiEpi, codiEpi2, ...baseNouEpi } = nouEpi;

    const baseDoc = {
      ...baseNouEpi,
      codiBomber: codiBomberFinal,
      estat: 'fora',
      estatNeteja: 'pendent',
      capsaTornada: false,
      epiTornat: false,
      dataRetornCapsa: '',
      dataRetornEpi: '',
      dataRetornFinal: '',
      logisticaEnviat: false,
      dataLogisticaEnviat: '',
      timestamp: serverTimestamp(),
    };

    const hasTwo = Boolean(codi2);
    const groupId = hasTwo ? generateGroupId() : null;


    const busyKey = 'assignar';
    if (isBusy(busyKey)) return;
    setBusyOn(busyKey);

    try {
      // EPI 1
      await addDoc(
        collection(
          db,
          'artifacts',
          appId,
          'public',
          'data',
          'epis_reg_registre',
        ),
        {
          ...baseDoc,
          codiEpi: codi1,
          assignacioGroupId: groupId,
          assignacioPos: 1,
          assignacioCount: hasTwo ? 2 : 1,
        },
      );

      // EPI 2 (opcional)
      if (hasTwo) {
        await addDoc(
          collection(
            db,
            'artifacts',
            appId,
            'public',
            'data',
            'epis_reg_registre',
          ),
          {
            ...baseDoc,
            codiEpi: codi2,
            assignacioGroupId: groupId,
            assignacioPos: 2,
            assignacioCount: 2,
          },
        );
      }

      showToast('Assignació guardada.', 'success');

      setNouEpi({
        codiEpi: '',
        codiEpi2: '',
        nomBomber: '',
        codiBomber: '',
        parc: 'Girona',
        regio: 'Girona',
        nomGD0: '',
        dataEntrega: new Date().toISOString().split('T')[0],
      });
      setActiveTab('home');
    } catch (err) {
      console.error('Error guardant EPI:', err);
      showToast('Error guardant l\'assignació. Torna-ho a provar.', 'error');
    }

    setBusyOff(busyKey);
  };

  // --- MARCAR NET / BRUT ---
  const marcarNetBrut = async (epi, estat) => {
  const busyKey = `netbrut:${epi.id}`;
  if (isBusy(busyKey)) return;
  setBusyOn(busyKey);

    try {
      await updateEpiStatus(epi.id, { estatNeteja: estat });
      showToast(`Marcat ${estat.toUpperCase()}.`, 'success');
    } catch (err) {
      console.error('Error marcant NET/BRUT:', err);
      showToast('Error actualitzant el resultat de la trucada.', 'error');
    }

    setBusyOff(busyKey);
  };
  // --- WHATSAPP GLOBAL (Pendents de recollir) ---
  const buildWhatsAppRecollirText = (items) => {
    const lines = ['Epis pendents de recollir:'];
    // ordenem per codi (G01..)
    const sorted = [...items].sort((a, b) =>
      (a.codiEpi || '').localeCompare(b.codiEpi || '', 'ca', { numeric: true }),
    );
    sorted.forEach((e) => {
      const estat = (e.estatNeteja || '').toLowerCase();
      lines.push(`${e.codiEpi} - ${e.parc} - ${estat}`);
    });
    return lines.join('\n');
  };

  const isMobileDevice = useMemo(() => {
    const ua = navigator.userAgent || '';
    return /Android|iPhone|iPad|iPod|Mobi/i.test(ua);
  }, []);

  const enviarWhatsAppGlobal = async () => {
  const busyKey = 'wa_send';
  if (isBusy(busyKey)) return;
  setBusyOn(busyKey);

    if (!pendentsRecollir.length) return;

    const text = buildWhatsAppRecollirText(pendentsRecollir);
    const href = `https://wa.me/?text=${encodeURIComponent(text)}`;

    // Marquem com enviat abans d'obrir WhatsApp (per evitar dobles clics)
    const today = new Date().toISOString().split('T')[0];
    try {
      await Promise.all(
        pendentsRecollir.map((e) =>
          updateEpiStatus(e.id, {
            logisticaEnviat: true,
            dataLogisticaEnviat: today,
          }),
        ),
      );
    } catch (err) {
      console.error('Error marcant logística enviat:', err);
      showToast('No he pogut marcar com “enviat”, però obro WhatsApp igualment.', 'error');
      // tot i així obrim WhatsApp perquè no es perdi la feina
    }

    window.open(href, '_blank', 'noopener,noreferrer');
    showToast('Obrint WhatsApp...', 'success');

    setBusyOff(busyKey);
  };

  const copiarWhatsAppGlobal = async () => {
  const busyKey = 'wa_copy';
  if (isBusy(busyKey)) return;
  setBusyOn(busyKey);

    const text = buildWhatsAppRecollirText(pendentsRecollir);
    try {
      await navigator.clipboard.writeText(text);
      showToast('Text copiat al porta-retalls.', 'success');
    } catch {
      // fallback
      prompt('Copia aquest text:', text);
      showToast('No he pogut copiar automàticament. Copia el text manualment.', 'error');
    }

    setBusyOff(busyKey);
  };

  // --- MODAL RETORN CAPSA / ROBA ---

  const obrirModalRetorn = (epi, tipus) => {
    setRetornModal({
      open: true,
      epi,
      tipus, // 'capsa' o 'epi'
      date: new Date().toISOString().split('T')[0],
    });
  };

  const tancarModalRetorn = () => {
    setRetornModal((prev) => ({
      ...prev,
      open: false,
      epi: null,
      tipus: null,
    }));
  };

  const guardarRetorn = async () => {
    if (!retornModal.open || !retornModal.epi || !retornModal.tipus) return;

    const busyKey = `retorn:${retornModal.epi?.id || ''}`;
    if (isBusy(busyKey)) return;
    setBusyOn(busyKey);

    const epi = retornModal.epi;
    const date = retornModal.date;
    const tipus = retornModal.tipus;

    let capsa = !!epi.capsaTornada;
    let roba = !!epi.epiTornat;

    const updates = {};

    if (tipus === 'capsa') {
      // Només capsa
      capsa = true;
      updates.capsaTornada = true;
      updates.dataRetornCapsa = date;
    } else if (tipus === 'epi') {
      // Capsa + EPI (tanca el cas)
      roba = true;
      capsa = true;
      updates.epiTornat = true;
      updates.capsaTornada = true;
      updates.dataRetornEpi = date;
      if (!epi.dataRetornCapsa) updates.dataRetornCapsa = date;
    } else if (tipus === 'epi_only') {
      // Només EPI (quan ja tenim la capsa prèviament)
      roba = true;
      updates.epiTornat = true;
      updates.dataRetornEpi = date;
      // Assegurem consistència: si per error no hi havia capsa marcada, la marquem també
      if (!epi.capsaTornada) {
        capsa = true;
        updates.capsaTornada = true;
        if (!epi.dataRetornCapsa) updates.dataRetornCapsa = date;
      }
    }

    if (capsa && roba) {
      updates.estat = 'tornat';
      updates.dataRetornFinal = date;
    } else if (capsa || roba) {
      updates.estat = 'parcial';
    } else {
      updates.estat = 'fora';
    }

    try {
      await updateEpiStatus(epi.id, updates);
      showToast('Retorn guardat.', 'success');
      tancarModalRetorn();
    } catch (err) {
      console.error('Error guardant retorn:', err);
      showToast('Error guardant el retorn.', 'error');
    }

    setBusyOff(busyKey);
  };

  // --- COLORS DE TARGETA SEGONS ESTAT ---
  const getCardClasses = (epi) => {
    // Capsa retornada però EPI no → EPI en rentat (groc)
    if (epi.capsaTornada && !epi.epiTornat) {
      return {
        bg: 'bg-amber-100',
        borderLeft: 'border-l-4 border-l-amber-500',
      };
    }

    // EPIs assignats (qualsevol estat de neteja mentre no siguin en rentat)
    return {
      bg: 'bg-red-100',
      borderLeft: 'border-l-4 border-l-red-500',
    };
  };

  // --- RENDERS ---

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">
        Carregant sistema REG...
      </div>
    );
  }

  const searchActive = (searchEpi || '').trim().length > 0;

  return (
    <div className={`min-h-screen font-sans pb-20 md:pb-0 relative ${theme === 'dark' ? 'theme-dark' : 'theme-light'}`}>
      <style>{`
        /* EPIGES theme overrides (no Tailwind dark mode required) */
        .theme-light { background: #f3f4f6; color: #111827; }
        .theme-dark { background: #0b1220; color: #e5e7eb; }

        .theme-dark .bg-white { background-color: rgba(17,24,39,0.92) !important; }
        .theme-dark .bg-gray-50 { background-color: rgba(31,41,55,0.90) !important; }
        .theme-dark .bg-gray-100 { background-color: rgba(55,65,81,0.85) !important; }

        .theme-dark .text-gray-900,
        .theme-dark .text-gray-800 { color: #e5e7eb !important; }
        .theme-dark .text-gray-700 { color: #cbd5e1 !important; }
        .theme-dark .text-gray-600,
        .theme-dark .text-slate-400 { color: #94a3b8 !important; }

        .theme-dark .border-gray-200 { border-color: rgba(148,163,184,0.25) !important; }
        .theme-dark .border-gray-100 { border-color: rgba(148,163,184,0.20) !important; }

        .theme-dark .shadow-sm { box-shadow: 0 1px 2px rgba(0,0,0,0.45) !important; }
        .theme-dark .shadow { box-shadow: 0 4px 12px rgba(0,0,0,0.55) !important; }

        /* Header readability in dark mode */
        .theme-dark header { background-color: rgba(2,6,23,0.92) !important; }
      `}</style>
{/* TOAST */}
      {toast.open && (
        <div className="fixed top-4 right-4 z-50 max-w-sm">
          <div
            className={`rounded-xl shadow-lg border px-4 py-3 flex items-start gap-2 ${
              toast.type === 'success'
                ? 'bg-green-50 border-green-200 text-green-900'
                : 'bg-rose-50 border-rose-200 text-rose-900'
            }`}
            role="status"
            aria-live="polite"
          >
            {toast.type === 'success' ? (
              <CheckCircle size={18} />
            ) : (
              <AlertCircle size={18} />
            )}
            <div className="text-sm font-semibold">{toast.message}</div>
          </div>
        </div>
      )}
      {/* HEADER */}
      <header className="bg-slate-900 text-white p-4 shadow-lg sticky top-0 z-20">
        <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
          <div>
            <h1 className="text-xl font-bold flex items-center gap-2">
              <span className="bg-red-600 px-2 py-1 rounded text-sm">REG</span>
              Gestió EPIs
            </h1>
            <p className="text-xs text-slate-400">
              Control de Contingència i Neteja
            </p>
          </div>

          {/* Navegació desktop */}
          <nav className="hidden md:flex gap-2 text-sm font-medium">
            <button
              onClick={() => setActiveTab('home')}
              className={`px-3 py-2 rounded-lg flex items-center gap-1 ${
                activeTab === 'home'
                  ? 'bg-white text-slate-900'
                  : 'text-slate-200 hover:bg-slate-800'
              }`}
            >
              <Truck size={16} />
              Actius
            </button>
            <button
              onClick={() => setActiveTab('assignar')}
              className={`px-3 py-2 rounded-lg flex items-center gap-1 ${
                activeTab === 'assignar'
                  ? 'bg-white text-slate-900'
                  : 'text-slate-200 hover:bg-slate-800'
              }`}
            >
              <Box size={16} />
              Assignar
            </button>
            <button
              onClick={() => setActiveTab('historic')}
              className={`px-3 py-2 rounded-lg flex items-center gap-1 ${
                activeTab === 'historic'
                  ? 'bg-white text-slate-900'
                  : 'text-slate-200 hover:bg-slate-800'
              }`}
            >
              <History size={16} />
              Històric
            </button>
          </nav>
          {/* Toggle tema (clar/fosc) */}
          <button
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            className="hidden md:inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-white/10 bg-white/5 hover:bg-white/10 text-slate-200 text-sm font-medium transition-colors"
            title="Canviar tema"
          >
            <span className="text-base">{theme === 'dark' ? '☀️' : '🌙'}</span>
            {theme === 'dark' ? 'Clar' : 'Fosc'}
          </button>


          {/* Botó Assignar destacat (escritori) */}
          <button
            onClick={() => setActiveTab('assignar')}
            className="hidden md:inline-flex bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium text-sm items-center gap-2 transition-colors shadow-sm"
          >
            <Box size={16} />
            Assignar EPI
          </button>
        </div>
      </header>

      <main className="max-w-6xl mx-auto p-4 space-y-6">
        {/* --- VISTA ASSIGNAR --- */}
        {activeTab === 'assignar' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
              <h2 className="font-semibold text-lg text-gray-800">
                Nova assignació d&apos;EPI
              </h2>
              <button
                onClick={() => setActiveTab('home')}
                className="text-gray-500 hover:text-gray-800 text-sm"
              >
                Cancel·lar
              </button>
            </div>

            <form onSubmit={handleAssignar} className="p-6 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Codi EPI */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Codi EPI (Ex: G23) *
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="G..."
                    className="w-full p-3 border border-gray-300 rounded-lg uppercase focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.codiEpi}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, codiEpi: e.target.value })
                    }
                  />
                </div>


                {/* Segon EPI (opcional) */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Segon EPI (opcional) — Pantaló o peça 2
                  </label>
                  <input
                    type="text"
                    placeholder="G..."
                    className="w-full p-3 border border-gray-300 rounded-lg uppercase focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.codiEpi2}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, codiEpi2: e.target.value })
                    }
                  />
                  <p className="text-xs text-gray-500">
                    Si omples aquest camp, es guardaran <b>2 registres</b> (jaquetó + pantaló) vinculats.
                  </p>
                </div>

                {/* Nom Bomber (opcional) */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Nom bomber (opcional)
                  </label>
                  <input
                    type="text"
                    placeholder="Cognom, Nom"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.nomBomber}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, nomBomber: e.target.value })
                    }
                  />
                </div>

                {/* Codi Bomber */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Codi bomber *
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="Ex: F416"
                    className="w-full p-3 border border-gray-300 rounded-lg uppercase focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.codiBomber}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, codiBomber: e.target.value })
                    }
                  />
                </div>

                {/* Parc (datalist) */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Parc destí *
                  </label>
                  <input
                    required
                    list="parcs-list"
                    type="text"
                    className="w-full p-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.parc}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, parc: e.target.value })
                    }
                  />
                  <datalist id="parcs-list">
                    {parcsDisponibles.map((p) => (
                      <option key={p} value={p} />
                    ))}
                  </datalist>
                </div>

                {/* Regió */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Regió d&apos;emergències
                  </label>
                  <select
                    className="w-full p-3 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.regio}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, regio: e.target.value })
                    }
                  >
                    {REGIONS.map((r) => (
                      <option key={r} value={r}>
                        {r}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Entregat per */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Entregat per (GD0) *
                  </label>
                  <input
                    required
                    type="text"
                    placeholder="El teu nom"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.nomGD0}
                    onChange={(e) =>
                      setNouEpi({ ...nouEpi, nomGD0: e.target.value })
                    }
                  />
                </div>

                {/* Data entrega */}
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Data entrega *
                  </label>
                  <input
                    required
                    type="date"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                    value={nouEpi.dataEntrega}
                    onChange={(e) =>
                      setNouEpi({
                        ...nouEpi,
                        dataEntrega: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="pt-4 border-t border-gray-100 flex justify-end">
                <button
                  type="submit"
                  disabled={isBusy('assignar')}
                  className={`bg-red-600 text-white px-6 py-3 rounded-lg font-bold shadow-md flex items-center gap-2 ${isBusy('assignar') ? 'opacity-60 cursor-not-allowed' : 'hover:bg-red-700'}`}
                >
                  <Save size={18} />
                  {isBusy('assignar') ? 'Guardant…' : 'Guardar assignació'}
                </button>
              </div>
            </form>
          </div>
        )}

        
        {/* --- VISTA HOME (3 BLOCS) --- */}
        {activeTab === 'home' && (
          <div className="space-y-6">
            {/* Bloc 1: Gestió */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="bg-blue-100 px-6 py-4 border-b border-blue-200 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Layers size={18} className="text-gray-700" />
                  <h2 className="font-semibold text-lg text-gray-900">Gestió (GD0)</h2>
                </div>
                <span className="text-xs text-gray-500">Feina diària</span>
              </div>

              <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-3">
                <button
                  onClick={() => setActiveTab('trucades')}
                  className="w-full text-left p-4 rounded-xl border border-amber-200 bg-amber-50 hover:bg-amber-100 transition"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Phone size={18} className="text-amber-800" />
                      <div className="font-bold text-amber-900">Trucades</div>
                    </div>
                    <div className="text-2xl font-extrabold text-amber-900">
                      {countsHome.trucades.toString().padStart(2, '0')}
                    </div>
                  </div>
                  <div className="mt-1 text-xs text-amber-900/70">
                    EPIs pendents de trucar (NET/BRUT)
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab('recollir')}
                  className="w-full text-left p-4 rounded-xl border border-blue-200 bg-blue-50 hover:bg-blue-100 transition"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <ArrowRight size={18} className={theme === 'dark' ? "text-blue-200" : "text-blue-800"} />
                      <div className="font-bold text-blue-900">Pendents de recollir</div>
                    </div>
                    <div className="text-2xl font-extrabold text-blue-900">
                      {countsHome.recollir.toString().padStart(2, '0')}
                    </div>
                  </div>
                  <div className="mt-1 text-xs text-blue-900/70">
                    Preparar missatge global a logística (WhatsApp)
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab('retorns')}
                  className="w-full text-left p-4 rounded-xl border border-rose-200 bg-rose-50 hover:bg-rose-100 transition"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <ClipboardCheck size={18} className={theme === 'dark' ? "text-rose-200" : "text-rose-800"} />
                      <div className="font-bold text-rose-900">Pendents de retorns</div>
                    </div>
                    <div className="text-2xl font-extrabold text-rose-900">
                      {countsHome.retorns.toString().padStart(2, '0')}
                    </div>
                  </div>
                  <div className="mt-1 text-xs text-rose-900/70">
                    (Trucades pendents + Recollir pendents)
                  </div>
                </button>
              </div>
            </div>

            {/* Bloc 2: Assignació */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className={theme === 'dark'
              ? "px-6 py-4 border-b border-slate-700/60 flex items-center justify-between bg-blue-900/20"
              : "px-6 py-4 border-b border-gray-100 flex items-center justify-between bg-blue-100"}>
                <div className="flex items-center gap-2">
                  <Box size={18} className="text-gray-700" />
                  <h2 className="font-semibold text-lg text-gray-900">Assignació</h2>
                </div>
                <span className="text-xs text-gray-500">Quan cal</span>
              </div>

              <div className="p-4">
                <button
                  onClick={() => setActiveTab('assignar')}
                  className="w-full p-4 rounded-xl border border-red-200 bg-red-50 hover:bg-red-100 transition flex items-center justify-between"
                >
                  <div className="flex items-center gap-2">
                    <Save size={18} className="text-red-700" />
                    <div className="font-bold text-red-900">Assignar EPI</div>
                  </div>
                  <ArrowRight size={18} className="text-red-700" />
                </button>
              </div>
            </div>

            {/* Bloc 3: Consulta */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <Search size={18} className="text-gray-700" />
                  <h2 className="font-semibold text-lg text-gray-900">Consulta</h2>
                </div>
                <span className="text-xs text-gray-500">Informació</span>
              </div>

              <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-3">
                <button
                  onClick={() => setActiveTab('estoc')}
                  className="w-full text-left p-4 rounded-xl border border-gray-200 bg-gray-50 hover:bg-gray-100 transition"
                >
                  <div className="flex items-center gap-2">
                    <List size={18} className="text-gray-700" />
                    <div className="font-bold text-gray-900 flex items-center gap-2 flex-wrap">Estoc REG</div>
                  </div>
                  <div className="mt-1 text-xs text-gray-600">
                    Llista G01..G40 amb peça i talla (estat calculat)
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab('cercador')}
                  className="w-full text-left p-4 rounded-xl border border-gray-200 bg-gray-50 hover:bg-gray-100 transition"
                >
                  <div className="flex items-center gap-2">
                    <Search size={18} className="text-gray-700" />
                    <div className="font-bold text-gray-900 flex items-center gap-2 flex-wrap">Cercador</div>
                  </div>
                  <div className="mt-1 text-xs text-gray-600">
                    Escriu G01 → on és / en estoc
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab('historic')}
                  className="w-full text-left p-4 rounded-xl border border-gray-200 bg-gray-50 hover:bg-gray-100 transition"
                >
                  <div className="flex items-center gap-2">
                    <History size={18} className="text-gray-700" />
                    <div className="font-bold text-gray-900">Històric</div>
                  </div>
                  <div className="mt-1 text-xs text-gray-600">
                    Assignacions retornades (per data)
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* --- VISTA PENDENTS DE RECOLLIR --- */}
        {activeTab === 'recollir' && (
          <div className={theme === 'dark'
            ? "bg-slate-900/40 rounded-xl shadow-sm border border-slate-700/60 overflow-hidden"
            : "bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"}>
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <ArrowRight size={18} className="text-blue-800" />
                <h2 className={theme === 'dark' ? "font-semibold text-lg text-blue-100" : "font-semibold text-lg text-blue-900"}>Pendents de recollir</h2>
              </div>
              <button onClick={() => setActiveTab('home')} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-700 shadow-sm">
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>

            <div className="p-4 space-y-3">
              <div className="flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
                <div className="text-sm text-gray-600">
                  Total: <span className="font-bold text-gray-900">{pendentsRecollir.length}</span>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={copiarWhatsAppGlobal}
                    className={`px-4 py-2 rounded-lg border border-gray-200 bg-white text-sm font-semibold flex items-center gap-2 ${(!pendentsRecollir.length || isBusy('wa_copy')) ? 'opacity-60 cursor-not-allowed' : 'hover:bg-gray-50'}`}
                    disabled={!pendentsRecollir.length || isBusy('wa_copy')}
                    title={!pendentsRecollir.length ? 'No hi ha pendents' : 'Copiar text'}
                  >
                    <Clipboard size={16} />
                    {isBusy('wa_copy') ? 'Copiant…' : 'Copiar'}
                  </button>

                  <button
                    onClick={enviarWhatsAppGlobal}
                    className={`px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-semibold flex items-center gap-2 ${(!pendentsRecollir.length || isBusy('wa_send')) ? 'opacity-60 cursor-not-allowed' : 'hover:bg-green-700'}`}
                    disabled={!pendentsRecollir.length || isBusy('wa_send')}
                    title={!pendentsRecollir.length ? 'No hi ha pendents' : 'Obrir WhatsApp amb el text'}
                  >
                    <MessageCircle size={16} />
                    {isBusy('wa_send') ? 'Obrint…' : 'Enviar WhatsApp (global)'}
                  </button>
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                {pendentsRecollir.length === 0 ? (
                  <div className="p-6 text-center text-gray-500">No hi ha EPIs pendents de recollir.</div>
                ) : (
                  <div className="space-y-3">
                    {pendentsRecollir
                      .slice()
                      .sort((a, b) => (a.codiEpi || '').localeCompare(b.codiEpi || '', 'ca', { numeric: true }))
                      .map((epi) => {
                        const estat = (epi.estatNeteja || '').toLowerCase();
                        const badgeColor = estat === 'net' ? 'green' : 'yellow';
                        return (
                          <div key={epi.id} className="p-4 rounded-2xl border border-green-200 bg-green-50 shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                            <div className="flex flex-col">
                              <div className="flex items-center gap-2 flex-wrap">
                                <span className="px-3 py-1 rounded-lg bg-slate-900 text-white font-mono font-extrabold">
                                  {epi.codiEpi}
                                </span>
                                {isDoubleAssign(epi) && <Badge color="purple">👥 Doble</Badge>}
                                {epi.regio && epi.regio !== 'Girona' && (
                                  <Badge color="purple">{epi.regio}</Badge>
                                )}
                                <span className="text-gray-800 font-bold">
                                  {epi.nomBomber ? `${epi.nomBomber} (${epi.codiBomber})` : `Bomber: ${epi.codiBomber}`}
                                </span>
                                <span className="text-gray-400 font-normal">—</span>
                                <span className="text-gray-700 font-semibold">{epi.parc}</span>
                              </div>
                              <div className="text-xs text-gray-500">
                                {estat === 'net' ? 'NET (EPI + capsa)' : 'BRUT (només capsa, EPI a ELIS)'}
                              </div>
                            </div>
                            <Badge color={badgeColor}>{estat.toUpperCase()}</Badge>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>

              {/* Previsualització del text */}
              {pendentsRecollir.length > 0 && (
                <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                  <div className="text-xs font-bold text-gray-700 mb-2">Text WhatsApp:</div>
                  <pre className="text-sm whitespace-pre-wrap text-gray-900">{buildWhatsAppRecollirText(pendentsRecollir)}</pre>
                </div>
              )}
            </div>
          </div>
        )}

        {/* --- VISTA PENDENTS DE RETORNS --- */}
        {activeTab === 'retorns' && (
          <div className={theme === 'dark'
            ? "bg-slate-900/40 rounded-2xl shadow-sm border border-slate-700/60 overflow-hidden"
            : "bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden"}>
            <div className={theme === 'dark'
              ? "px-6 py-4 border-b border-slate-700/60 flex items-center justify-between bg-rose-900/20"
              : "bg-rose-100 px-6 py-4 border-b border-rose-200 flex items-center justify-between"}>
              <div className="flex items-center gap-2">
                <ClipboardCheck size={18} className="text-rose-800" />
                <h2 className={theme === 'dark' ? "font-semibold text-lg text-rose-100" : "font-semibold text-lg text-rose-900"}>Pendents de retorns</h2>
              </div>
              <button onClick={() => setActiveTab('home')} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-700 shadow-sm">
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>

            <div className="p-4 space-y-4">
              <div className="text-sm text-gray-600">
                Marca <b>capsa</b> i/o <b>EPI</b> quan torni el material. Quan es marca <b>Capsa + EPI</b> (o l&apos;<b>EPI</b> final), el registre desapareix perquè ja està complet.
              </div>

              {pendentsRetorns.length === 0 ? (
                <div className="p-8 text-center text-gray-500">No hi ha pendents de retorn.</div>
              ) : (
                <div className="space-y-4">
                  {Object.entries(
                    pendentsRetorns.reduce((acc, e) => {
                      const parc = e.parc || 'Sense parc';
                      acc[parc] = acc[parc] || [];
                      acc[parc].push(e);
                      return acc;
                    }, {}),
                  )
                    .sort(([a], [b]) => a.localeCompare(b, 'ca', { sensitivity: 'base' }))
                    .map(([parc, items]) => {
                      const tel = parcPhones[parc] || PARC_PHONES[parc] || '';
                      return (
                        <div key={parc} className="border border-gray-200 rounded-2xl overflow-hidden">
                          <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
                            <div className="font-bold text-gray-900">{parc}</div>
                            <div className="text-sm">
                              <PhonePill tel={tel} tone="gray" />
                            </div>
                          </div>

                          <div className="p-4 space-y-3">
                            {items
                              .slice()
                              .sort((a, b) => {
                                const ab = (a.codiBomber || '').toString().localeCompare((b.codiBomber || '').toString(), 'ca', { numeric: true });
                                if (ab !== 0) return ab;
                                return (a.codiEpi || '').localeCompare(b.codiEpi || '', 'ca', { numeric: true });
                              })
                              .map((epi) => {
                                const neteja = (epi.estatNeteja || 'pendent').toLowerCase();
                                const trucadaFeta = neteja === 'net' || neteja === 'brut';

                                const capsaTornada = Boolean(epi.capsaTornada);
                                const epiTornat = Boolean(epi.epiTornat);

                                // Estils "d'un cop d'ull"
                                const cardTone = capsaTornada && !epiTornat
                                  ? { bg: 'bg-amber-50', border: 'border-amber-200' } // capsa ok, falta EPI (ELIS)
                                  : { bg: 'bg-rose-50', border: 'border-rose-200' };  // falta capsa (i EPI)

                                const regionIsGirona = !epi.regio || epi.regio === 'Girona';

                                return (
                                  <div
                                    key={epi.id}
                                    className={`rounded-2xl border ${cardTone.border} ${cardTone.bg} p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4`}
                                  >
                                    {/* ESQUERRA: info */}
                                    <div className="min-w-0">
                                      <div className="flex flex-wrap items-center gap-2">
                                        <span className="inline-flex items-center px-3 py-1 rounded-xl bg-gray-900 text-white font-extrabold font-mono text-sm">
                                          {epi.codiEpi}
                                        </span>

                                        {!regionIsGirona && (
                                          <span className="inline-flex">
                                            <Badge color="purple">{epi.regio}</Badge>
                                          </span>
                                        )}

                                        <span className="text-gray-700 font-semibold">
                                          {epi.nomBomber ? (
                                            <>
                                              {epi.nomBomber}{' '}
                                              <span className="text-gray-500 font-normal">
                                                ({epi.codiBomber})
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              Bomber:{' '}
                                              <span className="font-mono">{epi.codiBomber}</span>
                                            </>
                                          )}
                                        </span>
                                      </div>

                                      <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1 text-sm text-gray-700">
                                        <div>
                                          <span className="text-gray-500">Parc:</span> <span className="font-semibold">{epi.parc || '-'}</span>
                                        </div>
                                        <div>
                                          <span className="text-gray-500">Entrega:</span> <span className="font-semibold">{epi.dataEntrega || '-'}</span>
                                        </div>
                                        <div>
                                          <span className="text-gray-500">Entregat per:</span> <span className="font-semibold">{epi.nomGD0 || '-'}</span>
                                        </div>
                                        <div>
                                          <span className="text-gray-500">Retorn final:</span> <span className="font-semibold">{epi.dataRetornFinal || '-'}</span>
                                        </div>
                                      </div>

                                      <div className="mt-2 text-xs text-gray-600 flex flex-wrap items-center gap-2">
                                        <span className={`inline-flex items-center gap-1 ${trucadaFeta ? 'text-rose-800' : 'text-amber-800'}`}>
                                          <Phone size={14} />
                                          {trucadaFeta ? `Trucada feta: ${neteja.toUpperCase()}` : 'Trucada pendent'}
                                        </span>

                                        <span className="text-gray-400">·</span>

                                        <span>
                                          {capsaTornada ? (
                                            <>Capsa retornada <span className="text-gray-500">({epi.dataRetornCapsa || '-'})</span></>
                                          ) : (
                                            'Capsa pendent'
                                          )}
                                        </span>

                                        <span className="text-gray-400">·</span>

                                        <span>
                                          {epiTornat ? (
                                            <>EPI retornat <span className="text-gray-500">({epi.dataRetornEpi || '-'})</span></>
                                          ) : (
                                            'EPI pendent'
                                          )}
                                        </span>
                                      </div>
                                    </div>

                                    {/* DRETA: botons */}
                                    <div className="flex flex-wrap gap-2 justify-end">
                                      {/* CAPSA */}
                                      <button
                                        onClick={() => obrirModalRetorn(epi, 'capsa')}
                                        disabled={capsaTornada}
                                        className={`px-4 py-3 rounded-2xl border font-semibold text-sm flex items-center gap-2 ${
                                          capsaTornada
                                            ? 'bg-green-100 border-green-300 text-green-900 cursor-not-allowed'
                                            : 'bg-white border-gray-200 hover:bg-gray-50 text-gray-900'
                                        }`}
                                        title={capsaTornada ? `Capsa retornada el ${epi.dataRetornCapsa || ''}` : 'Marcar capsa buida'}
                                      >
                                        <Box size={16} />
                                        <div className="flex flex-col leading-tight">
                                          <span>Capsa buida</span>
                                          {capsaTornada && <span className="text-[11px] font-mono">{epi.dataRetornCapsa || '-'}</span>}
                                        </div>
                                      </button>

                                      {/* CAPSA + EPI (tanca) */}
                                      <button
                                        onClick={() => obrirModalRetorn(epi, 'epi')}
                                        className="px-4 py-3 rounded-2xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-900 font-semibold text-sm flex items-center gap-2"
                                        title="Marcar capsa + EPI (tanca el cas)"
                                      >
                                        <Box size={16} />
                                        <Shirt size={16} />
                                        Capsa + EPI
                                      </button>

                                      {/* EPI (només quan ja hi ha capsa) */}
                                      {capsaTornada && !epiTornat && (
                                        <button
                                          onClick={() => obrirModalRetorn(epi, 'epi_only')}
                                          className="px-4 py-3 rounded-2xl border border-gray-200 bg-white hover:bg-gray-50 text-gray-900 font-semibold text-sm flex items-center gap-2"
                                          title="Marcar només l'EPI (quan ja hi ha capsa)"
                                        >
                                          <Shirt size={16} />
                                          EPI
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        )}
{/* --- VISTA TRUCADES --- */}
        {activeTab === 'trucades' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="bg-amber-100 px-6 py-4 border-b border-amber-200 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Phone size={18} className="text-amber-800" />
                <h2 className="font-semibold text-lg text-amber-900">
                  EPIs pendents de trucada
                </h2>
              </div>
              <button
                onClick={() => setActiveTab('home')}
                className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-700 shadow-sm">
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>

            <div className="p-4">
              {perTrucar.length === 0 ? (
                <div className="p-8 text-center text-gray-500">
                  No hi ha EPIs pendents de trucada.
                </div>
              ) : (
                <div className="space-y-4">
                  {Object.entries(
                    perTrucar.reduce((acc, e) => {
                      const parc = e.parc || 'Sense parc';
                      acc[parc] = acc[parc] || [];
                      acc[parc].push(e);
                      return acc;
                    }, {}),
                  )
                    .sort(([a], [b]) => a.localeCompare(b, 'ca', { sensitivity: 'base' }))
                    .map(([parc, items]) => {
                      const tel = parcPhones[parc] || PARC_PHONES[parc] || '';return (
                        <div key={parc} className="border border-amber-200 rounded-xl overflow-hidden">
                          <div className="px-4 py-3 bg-amber-50 border-b border-amber-200 flex items-center justify-between gap-3">
                            <div className="font-bold text-amber-900">{parc}</div>

                            <div className="flex items-center gap-2">
                              <PhonePill tel={tel} tone="amber" />
                            </div>
                          </div>

                          <ul className="divide-y divide-amber-100">
                            {items
                              .slice()
                              .sort((a, b) => (a.codiEpi || '').localeCompare(b.codiEpi || '', 'ca', { numeric: true }))
                              .map((epi) => (
                                <li key={epi.id} className="p-4 rounded-2xl border border-amber-200 bg-white shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                  <div className="min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap">
                                      <span className="px-3 py-1 rounded-lg bg-slate-900 text-white font-mono font-extrabold">
                                        {epi.codiEpi}
                                      </span>
                                      {isDoubleAssign(epi) && <Badge color="purple">👥 Doble</Badge>}
                                      {epi.regio && epi.regio !== 'Girona' && (
                                        <Badge color="purple">{epi.regio}</Badge>
                                      )}
                                      <span className="text-gray-800 font-bold">
                                        {epi.nomBomber ? `${epi.nomBomber} (${epi.codiBomber})` : `Bomber: ${epi.codiBomber}`}
                                      </span>
                                    </div>
                                    <div className="text-xs text-gray-500">
                                      Data assignació: {epi.dataEntrega || '-'}
                                    </div>

                                    <input
                                      type="text"
                                      placeholder="Notes (opcional)"
                                      className="mt-2 w-full p-2 border border-gray-200 rounded-lg text-sm"
                                      value={epi.trucadaNotes || ''}
                                      onChange={async (e) => {
                                        // guardem notes en un camp simple (compatibilitat)
                                        await updateEpiStatus(epi.id, { trucadaNotes: e.target.value });
                                      }}
                                    />
                                  </div>

                                  <div className="flex flex-wrap gap-2">
                                    <button
                                      onClick={() => marcarNetBrut(epi, 'net')}
                                      disabled={isBusy(`netbrut:${epi.id}`)}
                                      className={`px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-semibold flex items-center gap-2 ${isBusy(`netbrut:${epi.id}`) ? 'opacity-60 cursor-not-allowed' : 'hover:bg-green-700'}`}
                                    >
                                      <Check size={16} />
                                      Net
                                    </button>
                                    <button
                                      onClick={() => marcarNetBrut(epi, 'brut')}
                                      disabled={isBusy(`netbrut:${epi.id}`)}
                                      className={`px-4 py-2 rounded-lg bg-amber-600 text-white text-sm font-semibold flex items-center gap-2 ${isBusy(`netbrut:${epi.id}`) ? 'opacity-60 cursor-not-allowed' : 'hover:bg-amber-700'}`}
                                    >
                                      <AlertCircle size={16} />
                                      Brut
                                    </button>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* --- VISTA ESTOC REG (informatiu) --- */}
        {activeTab === 'estoc' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <List size={18} className="text-gray-700" />
                <h2 className="font-semibold text-lg text-gray-900">Estoc REG</h2>
              </div>
              <button onClick={() => setActiveTab('home')} className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold text-gray-700 shadow-sm">
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>

            <div className="p-4">
              <div className="text-sm text-gray-600 mb-4">
                Aquesta vista és informativa. Ara mateix l’app no guarda Tipus/Talla; ho afegirem quan ho decideixis.
              </div>


              <div className="mb-4 flex flex-col md:flex-row gap-3 md:items-end">
                <div className="flex-1">
                  <div className="text-xs font-semibold text-gray-600">Cercar</div>
                  <input
                    value={estocSearch}
                    onChange={(e) => setEstocSearch(e.target.value)}
                    placeholder="Codi (G01), peça (Jaquetó), talla (MEDIUM)..."
                    className="mt-1 w-full px-3 py-2 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-gray-200"
                  />
                </div>

                <div className="w-full md:w-56">
                  <div className="text-xs font-semibold text-gray-600">Filtrar peça</div>
                  <select
                    value={estocFilterPeca}
                    onChange={(e) => setEstocFilterPeca(e.target.value)}
                    className="mt-1 w-full px-3 py-2 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-gray-200"
                  >
                    <option value="ALL">Totes</option>
                    <option value="Jaquetó">Jaquetó</option>
                    <option value="Pantaló">Pantaló</option>
                    <option value="NONE">Sense peça</option>
                  </select>
                </div>

                <div className="text-xs text-gray-500 md:pb-1">
                  Mostrant <span className="font-semibold text-gray-800">{estocRows.length}</span> / 40
                </div>
              </div>

              <div className="border border-gray-200 rounded-xl overflow-hidden">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="text-left px-4 py-3">
                        <button type="button" onClick={() => handleEstocSort('code')} className="inline-flex items-center gap-1 font-semibold text-gray-700">
                          Codi
                          {estocSortKey === 'code' && <span className="text-[10px]">{estocSortDir === 'asc' ? '▲' : '▼'}</span>}
                        </button>
                      </th>
                      <th className="text-left px-4 py-3">
                        <button type="button" onClick={() => handleEstocSort('peca')} className="inline-flex items-center gap-1 font-semibold text-gray-700">
                          Peça
                          {estocSortKey === 'peca' && <span className="text-[10px]">{estocSortDir === 'asc' ? '▲' : '▼'}</span>}
                        </button>
                      </th>
                      <th className="text-left px-4 py-3">
                        <button type="button" onClick={() => handleEstocSort('talla')} className="inline-flex items-center gap-1 font-semibold text-gray-700">
                          Talla
                          {estocSortKey === 'talla' && <span className="text-[10px]">{estocSortDir === 'asc' ? '▲' : '▼'}</span>}
                        </button>
                      </th>
                      <th className="text-left px-4 py-3">
                        <button type="button" onClick={() => handleEstocSort('estat')} className="inline-flex items-center gap-1 font-semibold text-gray-700">
                          Estat
                          {estocSortKey === 'estat' && <span className="text-[10px]">{estocSortDir === 'asc' ? '▲' : '▼'}</span>}
                        </button>
                      </th>
                      <th className="text-left px-4 py-3">
                        <button type="button" onClick={() => handleEstocSort('onEs')} className="inline-flex items-center gap-1 font-semibold text-gray-700">
                          On és
                          {estocSortKey === 'onEs' && <span className="text-[10px]">{estocSortDir === 'asc' ? '▲' : '▼'}</span>}
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {estocRows.map((row) => {
                      const code = row.code;
                      const estat = row.estat;
                      const onEs = row.onEs;
                      return (
                        <tr key={code} className="border-t border-gray-100">
                          <td className="px-4 py-3 font-mono font-bold">{code}</td>
                          <td className="px-4 py-3">
                            {row.peca && row.peca !== '—' ? row.peca : <span className="text-gray-400">—</span>}
                          </td>
                          <td className="px-4 py-3">
                            {row.talla ? (
                              row.talla === 'Desaparegut' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-semibold bg-red-50 text-red-700 border border-red-200">
                                  Desaparegut
                                </span>
                              ) : (
                                <span className="font-mono text-sm">{row.talla}</span>
                              )
                            ) : (
                              <span className="text-gray-400">—</span>
                            )}
                          </td>
                          <td className="px-4 py-3">{estat}</td>
                          <td className="px-4 py-3">{onEs}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        )}

        
        {/* --- VISTA CERCADOR (MVP) --- */}
        {activeTab === 'cercador' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Search size={18} className="text-gray-700" />
                <h2 className="font-semibold text-lg text-gray-800">Cercador d’EPI</h2>
              </div>
              <button
                onClick={() => setActiveTab('home')}
                className="px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 text-sm font-semibold flex items-center gap-2"
              >
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>

            <div className="p-4 space-y-4">
              <div className="text-sm text-gray-600">
                Escriu un <b>codi d’EPI</b> (ex: G01, G1, 01) o bé un <b>parc</b>, <b>codi bomber</b> o <b>nom</b>.
              </div>

              <div className="flex flex-col md:flex-row gap-2">
                <input
                  value={searchEpi}
                  onChange={(e) => setSearchEpi(e.target.value)}
                  placeholder="Ex: G01 / Girona / 1234 / Martí"
                  className="w-full p-3 border border-gray-300 rounded-xl"
                />
                <button
                  onClick={() => setSearchEpi('')}
                  className="px-4 py-3 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-sm font-semibold"
                >
                  Neteja
                </button>
              </div>

              {(() => {
                const raw = (searchEpi || '').trim();
                if (!raw) return null;

                const rawUp = raw.toUpperCase();
                const isCodeLike = /^G?\d{1,3}$/.test(rawUp);

                // Helper: normalitza "01" / "G1" -> "G01"
                const normalizeCode = (s) => {
                  let q = (s || '').trim().toUpperCase();
                  if (!q) return '';
                  if (!q.startsWith('G')) q = `G${q}`;
                  const n = q.replace(/^G/, '');
                  if (!/^\d+$/.test(n)) return q;
                  const padded = n.padStart(2, '0');
                  return `G${padded}`;
                };

                const term = raw.toLowerCase();

                // Si és un codi, prioritzem resultat "on és ara" + històric d'aquell codi
                if (isCodeLike) {
                  const code = normalizeCode(rawUp);

                  const matches = (epis || [])
                    .filter((e) => (e.codiEpi || '').toUpperCase() === code)
                    // ja venen bastant ordenats, però assegurem
                    .sort(
                      (a, b) =>
                        new Date(b.dataEntrega || b.timestamp?.toDate?.() || 0) -
                        new Date(a.dataEntrega || a.timestamp?.toDate?.() || 0),
                    );

                  const latest = matches[0];

                  const formatDate = (d) => {
                    if (!d) return '';
                    try {
                      // d pot ser string 'YYYY-MM-DD' o Timestamp
                      if (typeof d === 'string') return d;
                      if (d?.toDate) return d.toDate().toLocaleString();
                      return new Date(d).toLocaleString();
                    } catch {
                      return '';
                    }
                  };

                  if (!latest) {
                    return (
                      <div className="p-4 rounded-xl border border-green-200 bg-green-50">
                        <div className="font-bold text-green-900 text-lg">{code}</div>
                        <div className="text-sm text-green-800">No hi ha cap assignació registrada → <b>A REG (estoc)</b></div>
                      </div>
                    );
                  }

                  const parc = latest.parc || '—';
                  const regio = latest.regio || '—';
                  const bomber = `${latest.nomBomber || '—'} (${latest.codiBomber || '—'})`;

                  const neteja = (latest.estatNeteja || 'pendent').toLowerCase();
                  const capsa = Boolean(latest.capsaTornada);
                  const epi = Boolean(latest.epiTornat);

                  let estatNow = 'Fora';
                  let accent = 'red';

                  if (epi) {
                    estatNow = 'A REG (EPI retornat)';
                    accent = 'green';
                  } else if (capsa && !epi) {
                    estatNow = neteja === 'pendent' ? 'Fora (capsa a REG · pendent trucada)' : `Fora (capsa a REG · ${neteja})`;
                    accent = 'amber';
                  } else {
                    estatNow = neteja === 'pendent' ? 'Fora (pendent trucada)' : `Fora (${neteja})`;
                    accent = 'red';
                  }

                  const boxCls =
                    accent === 'green'
                      ? 'border-green-200 bg-green-50 text-green-900'
                      : accent === 'amber'
                        ? 'border-amber-200 bg-amber-50 text-amber-900'
                        : 'border-red-200 bg-red-50 text-red-900';

                  return (
                    <div className="space-y-4">
                      <div className={`p-4 rounded-xl border ${boxCls}`}>
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                          <div>
                            <div className="font-bold text-xl">{code}</div>
                            <div className="text-sm opacity-90">Estat: <b>{estatNow}</b></div>
                          </div>
                          <div className="text-sm opacity-90">
                            <div><b>Parc:</b> {parc}</div>
                            <div><b>Regió:</b> {regio}</div>
                          </div>
                        </div>

                        <div className="mt-3 text-sm opacity-90 grid grid-cols-1 md:grid-cols-2 gap-2">
                          <div><b>Assignat a:</b> {bomber}</div>
                          <div><b>Data entrega:</b> {formatDate(latest.dataEntrega || latest.timestamp)}</div>
                          {capsa && (
                            <div><b>Retorn capsa:</b> {latest.dataRetornCapsa || '—'}</div>
                          )}
                          {epi && (
                            <div><b>Retorn EPI:</b> {latest.dataRetornFinal || latest.dataRetornEpi || '—'}</div>
                          )}
                        </div>
                      </div>

                      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                          <div className="font-semibold text-gray-800">Històric recent ({Math.min(matches.length, 20)} de {matches.length})</div>
                          <div className="text-xs text-gray-500">Últimes entrades</div>
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full text-sm text-left text-gray-700">
                            <thead className="bg-gray-50 text-gray-700 font-semibold border-b">
                              <tr>
                                <th className="px-4 py-3">Entrega</th>
                                <th className="px-4 py-3">Parc</th>
                                <th className="px-4 py-3">Neteja</th>
                                <th className="px-4 py-3">Capsa</th>
                                <th className="px-4 py-3">EPI</th>
                              </tr>
                            </thead>
                            <tbody>
                              {matches.slice(0, 20).map((r) => (
                                <tr key={r.id} className="border-b last:border-b-0">
                                  <td className="px-4 py-3">{formatDate(r.dataEntrega || r.timestamp) || '—'}</td>
                                  <td className="px-4 py-3">{r.parc || '—'}</td>
                                  <td className="px-4 py-3">{(r.estatNeteja || 'pendent').toUpperCase()}</td>
                                  <td className="px-4 py-3">{r.capsaTornada ? (r.dataRetornCapsa || '✅') : '—'}</td>
                                  <td className="px-4 py-3">{r.epiTornat ? (r.dataRetornFinal || r.dataRetornEpi || '✅') : '—'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  );
                }

                // Si NO és codi, fem cerca general (parc / bomber / nom) sobre llistat carregat
                const results = (epis || [])
                  .filter((e) => {
                    const parc = (e.parc || '').toString().toLowerCase();
                    const regio = (e.regio || '').toString().toLowerCase();
                    const codiBomber = (e.codiBomber || '').toString().toLowerCase();
                    const nom = (e.nomBomber || '').toString().toLowerCase();
                    const codi = (e.codiEpi || '').toString().toLowerCase();
                    return (
                      parc.includes(term) ||
                      regio.includes(term) ||
                      codiBomber.includes(term) ||
                      nom.includes(term) ||
                      codi.includes(term)
                    );
                  })
                  .sort(
                    (a, b) =>
                      new Date(b.dataEntrega || b.timestamp?.toDate?.() || 0) -
                      new Date(a.dataEntrega || a.timestamp?.toDate?.() || 0),
                  )
                  .slice(0, 50);

                if (!results.length) {
                  return (
                    <div className="p-4 rounded-xl border border-gray-200 bg-gray-50 text-gray-700">
                      Sense resultats per <b>{raw}</b>
                    </div>
                  );
                }

                return (
                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
                    <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                      <div className="font-semibold text-gray-800">Resultats ({results.length} / 50)</div>
                      <div className="text-xs text-gray-500">Cerca general</div>
                    </div>
                    <div className="divide-y">
                      {results.map((r) => (
                        <div key={r.id} className="p-4">
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                            <div className="font-bold text-gray-900 flex items-center gap-2">
                              <span className="px-2 py-1 rounded-lg bg-gray-900 text-white text-xs">{r.codiEpi || '—'}</span>
                              <span className="text-sm">{r.nomBomber || '—'} <span className="text-gray-500">({r.codiBomber || '—'})</span></span>
                            </div>
                            <div className="text-xs text-gray-500">
                              {(() => {
                                try {
                                  if (typeof r.dataEntrega === 'string') return r.dataEntrega;
                                  if (r.timestamp?.toDate) return r.timestamp.toDate().toLocaleString();
                                  return '';
                                } catch {
                                  return '';
                                }
                              })()}
                            </div>
                          </div>
                          <div className="mt-2 text-sm text-gray-700 flex flex-wrap gap-2">
                            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-gray-100">
                              <MapPin size={14} /> {r.parc || '—'} · {r.regio || '—'}
                            </span>
                            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-gray-100">
                              <CheckCircle size={14} /> {(r.estatNeteja || 'pendent').toUpperCase()}
                            </span>
                            {r.capsaTornada && (
                              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-amber-100 text-amber-900">
                                <Box size={14} /> Capsa OK
                              </span>
                            )}
                            {r.epiTornat && (
                              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-lg bg-green-100 text-green-900">
                                <Shirt size={14} /> EPI retornat
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        )}


{activeTab === 'historic' && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h2 className="font-semibold text-lg text-gray-800">Històric de retorns</h2>
              <button
                onClick={() => setActiveTab('home')}
                className={theme === 'dark'
                  ? "inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-slate-800/60 border border-slate-600/60 hover:bg-slate-800 text-sm font-semibold text-slate-100 shadow-sm"
                  : "inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white border border-gray-200 hover:bg-gray-50 text-sm font-semibold text-gray-700 shadow-sm"}
              >
                <ArrowLeft size={16} />
                Tornar
              </button>
            </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-600">
                <thead className="bg-gray-50 text-gray-700 font-semibold border-b">
                  <tr>
                    <th className="px-6 py-3">Codi</th>
                    <th className="px-6 py-3">Bomber</th>
                    <th className="px-6 py-3">Parc / Regió</th>
                    <th className="px-6 py-3">Entrega</th>
                    <th className="px-6 py-3">Capsa</th>
                    <th className="px-6 py-3">Roba</th>
                    <th className="px-6 py-3">Retorn final</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {historics.map((h) => (
                    <tr key={h.id} className="hover:bg-gray-50">
                      <td className="px-6 py-3 font-bold text-gray-800">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="font-mono">{h.codiEpi}</span>
                          {isDoubleAssign(h) && (
                            <Badge color="purple">👥 Doble</Badge>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-3">
                        {h.nomBomber || '-'} ({h.codiBomber})
                      </td>
                      <td className="px-6 py-3">
                        {h.parc}
                        {h.regio && h.regio !== 'Girona' && (
                          <span className="block text-xs text-purple-600">
                            {h.regio}
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-3">{h.dataEntrega || '-'}</td>
                      <td className="px-6 py-3">
                        {h.dataRetornCapsa || h.dataRetornFinal || '-'}
                      </td>
                      <td className="px-6 py-3">
                        {h.dataRetornEpi || h.dataRetornFinal || '-'}
                      </td>
                      <td className="px-6 py-3">
                        {h.dataRetornFinal || '-'}
                      </td>
                    </tr>
                  ))}
                  {historics.length === 0 && (
                    <tr>
                      <td
                        colSpan={7}
                        className="px-6 py-8 text-center text-gray-400 text-sm"
                      >
                        {searchActive
                          ? 'No hi ha coincidències a l’històric amb aquest codi.'
                          : 'Encara no hi ha EPIs marcats com a retornats.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </main>

      {/* NAV INFERIOR MÒBIL */}
      <nav className="md:hidden fixed bottom-0 w-full bg-white border-t border-gray-200 flex justify-around p-2 pb-safe z-50 text-xs font-medium text-gray-500 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
        <button
          onClick={() => setActiveTab('home')}
          className={`flex flex-col items-center p-2 rounded ${
            activeTab === 'home' ? 'text-red-600 bg-red-50' : ''
          }`}
        >
          <Truck size={20} />
          <span>Actius</span>
        </button>
        <button
          onClick={() => setActiveTab('assignar')}
          className={`flex flex-col items-center p-2 rounded ${
            activeTab === 'assignar' ? 'text-red-600 bg-red-50' : ''
          }`}
        >
          <Box size={20} />
          <span>Assignar</span>
        </button>
        <button
          onClick={() => setActiveTab('historic')}
          className={`flex flex-col items-center p-2 rounded ${
            activeTab === 'historic' ? 'text-red-600 bg-red-50' : ''
          }`}
        >
          <History size={20} />
          <span>Històric</span>
        </button>

        <button
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          className="flex flex-col items-center p-2 rounded"
          title="Canviar tema"
        >
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
          <span>Tema</span>
        </button>

      </nav>

      {/* MODAL RETORN CAPSA / ROBA */}
      {retornModal.open && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm">
            <h3 className="font-semibold text-lg text-gray-800 mb-2">
              Marcar retorn{' '}
              {retornModal.tipus === 'capsa'
                ? 'de la capsa'
                : retornModal.tipus === 'epi'
                  ? 'capsa + EPI'
                  : "de l'EPI"}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              EPI <span className="font-semibold">{retornModal.epi?.codiEpi}</span>{' '}
              — {retornModal.epi?.parc}
            </p>
            <label className="text-sm font-medium text-gray-700 block mb-2">
              Data de retorn
            </label>
            <input
              type="date"
              className="w-full p-3 border border-gray-300 rounded-lg mb-6 focus:ring-2 focus:ring-red-500 focus:border-red-500"
              value={retornModal.date}
              onChange={(e) =>
                setRetornModal((prev) => ({
                  ...prev,
                  date: e.target.value,
                }))
              }
            />
            <div className="flex justify-end gap-2">
              <button
                type="button"
                onClick={tancarModalRetorn}
                className="px-4 py-2 rounded-lg text-sm text-gray-600 hover:bg-gray-100"
              >
                Cancel·lar
              </button>
              <button
                type="button"
                onClick={guardarRetorn}
                disabled={isBusy(`retorn:${retornModal.epi?.id || ''}`)}
                className={`px-4 py-2 rounded-lg text-sm bg-red-600 text-white font-medium ${isBusy(`retorn:${retornModal.epi?.id || ''}`) ? 'opacity-60 cursor-not-allowed' : 'hover:bg-red-700'}`}
              >
                {isBusy(`retorn:${retornModal.epi?.id || ''}`) ? 'Guardant…' : 'Guardar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}